<template>
    <b-card>
        <b-row>
            <b-col class="col-md-12">
                <b-skeleton-table
                    :rows="5"
                    :columns="5"
                    :table-props="{ bordered: true, striped: true }"
                    v-if="loading"
                ></b-skeleton-table>
                <vue-good-table
                    v-else
                    :columns="columns"
                    :rows="rows"
                    :current-page="currentPage"
                    :pagination-options="{
                    enabled: true,
                    perPage:pageLength
                }"
                >
                    <template
                        slot="table-row"
                        slot-scope="props"
                    >
                    <span v-if="props.column.field === 'action'">
                        <b-badge variant='info'>
                            <a @click="getURLDocument(props.row.action)" target="_blank">
                                {{ 'Gerar arquivo PDF' }}
                            </a>
                      </b-badge>
                    </span>
                    </template>

                    <template
                        slot="pagination-bottom"
                        slot-scope="props"
                    >
                        <div class="d-flex justify-content-between flex-wrap">
                            <div class="d-flex align-items-center mb-0 mt-1">
                                <span class="text-nowrap"> Total de {{ total }} registros </span>
                            </div>
                            <div>
                                <b-pagination
                                    :value="1"
                                    :total-rows="total"
                                    :per-page="pageLength"
                                    first-number
                                    last-number
                                    align="right"
                                    prev-class="prev-item"
                                    next-class="next-item"
                                    class="mt-1 mb-0"
                                    @input="getIncomeTax"
                                    v-model="currentPage"
                                >
                                    <template #prev-text>
                                        <feather-icon
                                            icon="ChevronLeftIcon"
                                            size="18"
                                        />
                                    </template>
                                    <template #next-text>
                                        <feather-icon
                                            icon="ChevronRightIcon"
                                            size="18"
                                        />
                                    </template>
                                </b-pagination>
                            </div>
                        </div>
                    </template>

                </vue-good-table>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import IncomeTaxService from "@/services/IncomeTaxService";
import getEndPoint from "@/config/getEndPoint";

import { VueGoodTable } from 'vue-good-table'

import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
    name: "IncomeTax",
    components:{
        VueGoodTable
    },
    mounted() {
        this.getIncomeTax()
    },
    data(){
        return {
            pageLength: null,
            currentPage: null,
            total: null,
            columns: [
                {
                    label: 'Ano competência',
                    field: 'ano_competencia',
                    sortable: false
                },
                {
                    label: 'Ações',
                    field: 'action',
                    sortable: false
                },
            ],
            rows: [],
            loading: false,
        }
    },
    methods:{
        getURLDocument(id) {
            this.loading = true;
            IncomeTaxService.getURL(id).then(resp => {
                this.loading = false;
                window.open(resp.data, '_blank').focus();
            }).catch(err => {
                this.loading = false;
                this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Oops!',
                            icon: 'BellIcon',
                            text: 'Ocorreu um erro ao gerar o arquivo.',
                            variant: 'danger',
                        },
                    },
                    {
                        position: 'top-center'
                    })
            })
        },
        statusVariant(status) {
            return status ? 'success' : 'danger';
        },
        getIncomeTax(page = 1){
            this.currentPage = page;
            this.loading = true;

            IncomeTaxService.get(page).then(resp => {
                this.rows = resp.data.data.map(item => {
                    return {
                        ano_competencia: item.ano_competencia,
                        action: item.id
                    }
                })

                this.perPage = resp.data.per_page;
                this.total = resp.data.total;
                this.loading = false;
            }).catch(err => {
                this.loading = false;
                this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Oops!',
                            icon: 'BellIcon',
                            text: 'Ocorreu um erro ao buscar os dados.',
                            variant: 'danger',
                        },
                    },
                    {
                        position: 'top-center'
                    })
            })
        }
    }
}
</script>

<style>

</style>
